// extracted by mini-css-extract-plugin
export default {"modal-title":"styles__modal-title--yOukB","modal-subtitle":"styles__modal-subtitle--WMUZ6","modal-scroll":"styles__modal-scroll--ERrpS"};